module.exports = __webpack_public_path__ + "img/bottom.36b1890e.png";